
import { defineComponent } from 'vue';
import { Icon } from '@iconify/vue';

export default defineComponent({
  name: 'CheckoutAddressCard',
  components: { Icon },
  emits: ['select-address', 'search-cep', 'use-new-address', 'delete-address', 'update:cep', 'update:number', 'update:complement'],
  props: {
    userAddresses: { type: Object, required: true },
    selectedAddress: { type: Object, required: true },
    address: { type: Object, required: true },
    cep: { type: String, required: true },
    number: { type: String, required: true },
    complement: { type: String, required: true },
    showNewAddressForm: { type: Boolean, required: true },
    savingAddress: { type: Boolean, required: true },
    deletingAddressId: { type: Number, default: 0 },
  },
  computed: {
    normalizedAddresses(): Array<any> {
      const addresses: Array<any> = [];
      const cadastro = (this.userAddresses as any).endereco_cadastro;
      const entregas = (this.userAddresses as any).endereco_entrega || [];

      if (cadastro?.id) {
        addresses.push({ ...cadastro, type: 'cadastro' });
      }

      entregas.forEach((item: any, index: number) => {
        addresses.push({ ...item, type: 'entrega', order: index + 2 });
      });

      return addresses;
    },
  },
  methods: {
    isSelected(item: any) {
      return (this.selectedAddress as any).type === item.type && (this.selectedAddress as any).id === item.id;
    },
    formatAddress(item: any) {
      const streetAndNumber = [item.street, item.number].filter(Boolean).join(', ');
      const complement = item.complement ? `— ${item.complement}` : '';

      return [streetAndNumber, complement, item.neighborhood, item.city ? `${item.city}/${item.state}` : '']
        .filter(Boolean)
        .join(', ');
    },
  },
});
